var map = {
	"./female-1.jpg": 9093,
	"./female-2.jpg": 7018,
	"./female-3.jpg": 4759,
	"./female-4.jpg": 6860,
	"./man-1.jpg": 2873,
	"./man-2.jpg": 6142,
	"./man-3.jpg": 7627,
	"./man-4.jpg": 7624,
	"./man-5.jpg": 4789,
	"./man-6.jpg": 2186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6529;